<template>
  <div class="col-md-12 mb-2">
    <b-card>
      <div slot="header">
        <b>Edit RM Approval Pending</b>
        <button type="button" aria-label="Close" class="close" @click="$emit('prevPage')">Back</button>
      </div>
      <form>
        <div class="card-body1">
          <div class="form-group row">
            <div class="col-md-12">
              <b-form-fieldset label="AWB Number :" description="">
                <b-input-group left="<i class='fa fa-book'></i>">
                  <input class="form-control" id="awbnumber" name="awbnumber" v-model="awbnumberObject.awbnumber"
                    :disabled="disableFields" type="text"></b-form-input>
                  <b-input-group-button slot="right">
                  </b-input-group-button>
                </b-input-group>
              </b-form-fieldset>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <b-form-fieldset name="takeActionn" label="Take Action: <span style='color: red'>*</span> " :label-cols="2"
                :horizontal="true">
                <div class="takeActionRadio">
                  <div v-for="(n, index) in takeactionlist" :key="index" @change="selectData(n.id, n.label)"
                    class="takeactionradiobtns" style="padding-right:2.5%">
                    <input type="radio" :name="n.label" :value="n.id" v-model="takeActionname">
                    {{ n.label }}
                  </div>
                </div>
              </b-form-fieldset>
            </div>
          </div>


          <div class="form-group-row image-upload">
            <label for="upload">Upload images or videos</label>
            <b-input-group class="imageUploadClass">
              <input id="upload" type="file" @change="onImageFileChange($event)" multiple="multiple">
            </b-input-group>
            <div class="imageGroup">
              <div class="image-view-upload row" v-bind:key="index" v-for="(image, index) in images">
                <img @click="downloadImage(image)" class="col-md-offset-1 col-md-2 col-sm-3 col-xs-4" :src="image.url"
                  onerror="this.src='static/img/vp.svg';" />
                <button @click="removeImage(index)" class="btn btn-danger"><i class="fa fa-trash-o"
                    style="font-size:25px"></i></button>
              </div>
            </div>
          </div>

        </div>

        <div class="form-group row static-images">
          <div class="col-md-12">
            <p>Media uploaded by executive:</p>
            <div key="index" class="media-item">
              <template v-for="(img, index) in assetsByExecutive">
                <img :src="img.path" class="image-preview" @click="showImage(img)" :key="index" alt="Image Preview"
                  onerror="this.src='static/img/vp.svg';">
              </template>
            </div>
          </div>
        </div>

          <div class="form-group row">
            <div class="col-md-12">
              <p>Images/Video uploaded by client:</p>
              <div v-for="(item, index) in assetsClient" :key="index" class="media-container">
                <div class="image-container">
                  <template v-for="img in clientImages">
                  <template v-if="img.attachment">
                    <iframe v-if= "isGoogleDriveLink(img.attachment)" class="media image-preview" :src="convertToEmbedUrl(img.attachment)" frameborder="0" allowfullscreen></iframe>
                    <img v-else :src="img.attachment" class="image-preview" alt="Image Preview" @click="showMediaOfImage(img.attachment)" onerror="this.src='static/img/img-ph.png';">
                    </template>
                  </template>
                </div>
                <div class="video-container">
                  <div v-for="vid in item.vediourl" :key="vid.UnboxingVideoProof1">
                  <template v-if="vid.UnboxingVideoProof1">
                    <iframe v-if= "isGoogleDriveLink(vid.UnboxingVideoProof1)" class="media video-preview" :src="convertToEmbedUrl(vid.UnboxingVideoProof1)" frameborder="0" allowfullscreen> </iframe>
                    <video v-else :src="vid.UnboxingVideoProof1" class="video-preview" controls>
                      Your browser does not support the video tag.
                    </video>
                    </template>
                  </div>
                    <div class="download-button">
                    <button @click="downloadVideo(vid.UnboxingVideoProof1)">
                      Download Video
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

        <div class="form-group row">
          <div class="col-md-6">
            <label>Description :</label>
            <span style='color: red'>*</span>
            <b-input-group>
              <textarea class="form-control" id="description" name="description" v-model="description"
                rows="3"></textarea>
            </b-input-group>
          </div>
        </div>
        <div class="card-footer">
          <b-button class="btn btn-sm btn-success"
            @click="$emit('updateDetails', awbnumberObject.awbnumber, takeactionid, description, uploadImageQueue())"
            type="button"><i class="fa fa-check"></i>
            <span>Submit</span>
          </b-button>
          <button class="btn btn-sm btn-danger" @click="resetForm()" type="button"> Reset <i
              class="fa fa-refresh"></i></button>

        </div>
      </form>
    </b-card>
    <b-modal id="imgPopUp" v-model="showModal" title="BootstrapVue">
      <b-card v-bind:class="(Isvideo) ? 'card-body-width' : ''">
        <span class="download-btn"><i class="fa fa-download"></i> <a :href="imgData" download>Download</a> </span>
        <span @click="closeImage()">X</span>
        <img v-if="!Isvideo" :src="imgData" alt="loading...">
        <video v-if="Isvideo" ref="videoPlayer" controls></video>
      </b-card>
    </b-modal>
  </div>
</template>


<style src="./actionComponent.component.scss" scoped lang="scss"></style>

<script>
import Multiselect from "vue-multiselect";
import { uploadDisputeFiles } from '../../services/externalDispute';
import { actionStatuses } from '../../services/actionStatus';
import { fetchimageObject, extractObjectFromKey, fetchClientImages,getImage,getVideoUrl } from '../../services/externalDispute';
import { isValidUrl } from '../../services/utility';
import awsBucketName from '../../constants';


export default {
  name: "actionComponent",
  components: {
    Multiselect,
  },
  props: {
    awbnumberObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      val: 0,
      awbnumber: "",
      img: '',
      takeactionid: '',
      takeActionname: '',
      description: '',
      showModal: false,
      //showupload:true,
      disableFields: true,
      imagesarr: [],
      attachment: null,
      FileSelected: null,
      images: [],
      takeactionlist: [],
      myStr: '',
      assetsClient: [],
      assetsByExecutive: [],
      Isvideo: false,
      imgData: '',
      clientImages:[],
      assetsClientValue:''

    };
  },
  mounted() {
    var userToken = window.localStorage.getItem("accessuserToken");
    this.myStr = userToken.replace(/"/g, "");
    this.takeAction();

  },
  watch: {
    awbnumberObject: [
      {
        handler: "manageInformation",
      },
    ],
  },
  methods: {
    manageInformation(obj) {
      this.awbnumber = obj.awbnumber;
      this.getXBAssets('img');
      this.getImages();
    },
    selectData(id) {
      this.takeactionid = id
    },
    async takeAction() {
      this.takeactionlist = await actionStatuses(20, 6, this.myStr);
    },
     getImages(){
      let input = {"shippingid": this.awbnumber}
      fetchClientImages(input,this.myStr).then(img=>{
       this.assetsClient = img.data.data;
     this.assetsClient[0].imageurl.forEach(obj => {
     this.assetsClientValue = Object.values(obj);
   });
    this.assetsClient[0].vediourl.forEach(obj => {
    Object.entries(obj).forEach(([objKey, vid]) => {
      if (vid && !isValidUrl(vid)) {
        let videoInput = {
          key: vid
        };
        getVideoUrl(videoInput, this.myStr).then(videoData => {
          obj[objKey] = videoData.data.data[0].url;
        });
      }
    });
    });
     this.assetsClientValue.forEach(img => {
       if(isValidUrl(img) == false && img !== null) {
       let input = {
                   bucketName: awsBucketName.awsBucketName,
                   key:img
                 };
       getImage(input,this.token).then(imagesData => {
              let finalImage = imagesData.data.ImageData
               this.clientImages.push({attachment:finalImage})                         
           });
         }
         else{
           this.clientImages.push({attachment:img})                         
         }
       });
   });
},
   async showMediaOfImage(url){
     this.imgData = url;
     this.showModal = true;
   },
    onFileChange(event) {
      if (this.images.length > 4) {
        this.$alertify.error("Maximum 5 images can be upload");
      }
      else {
        this.attachment = event.target.files[0];

        const fr = new FileReader();
        fr.onload = () => {
          this.images.push({ attachment: this.attachment, url: fr.result });
        };
        fr.readAsDataURL(this.attachment);

        this.FileSelected = this.attachment;
        this.FileSelected = null;
      }
    },
    deleteImage(imageIndex) {
      if (imageIndex > -1) {
        this.images.splice(imageIndex, 1);
      }
    },
    uploadImageQueue() {
      this.images.forEach(img => {
        let retry = 0;
        let form = new FormData();
        form.append('file', img.attachment);
        form.append('shippingid', this.awbnumberObject.awbnumber);


        uploadDisputeFiles(form, this.myStr).then(res => {
          if (!res.status && retry < 5) {
            uploadDisputeFiles(form, this.myStr);
            retry++
          }
        }).catch();
      });
    },
    resetForm() {
      this.takeactionid = '',
        this.description = '',
        this.$validator.reset(); this.errors.clear();
    },

    onImageFileChange(event, folder) {
      let multipleFiles = [...event.target.files];
      multipleFiles.forEach((file) => {
        this.attachment = file;
        let fileType = file.type.split('/')[0];
          if(fileType.toLowerCase() === 'image' && file.size > 2000000) {
            this.$alertify.error("Image should not be greater than 2 MB") 
            return;
          }
          if(fileType.toLowerCase() === 'video' && file.size > 10000000) {
            this.$alertify.error("Video should not be greater than 10 MB") 
            return;
          }
        const fr = new FileReader();
        fr.onload = () => {
          if(this.images.length == 5 && fileType.toLowerCase() === 'image'){
            this.$alertify.error("max 5 images are allowed.") 
            return;
          }
          if(this.images.length == 1 && fileType.toLowerCase() === 'video'){
            this.$alertify.error("max 1 vide is allowed.") 
            return;
          }
          this.images.push({ attachment: file, url: fr.result });
        };
        fr.readAsDataURL(file);

        this.FileSelected = this.attachment;
        this.FileSelected = null;
      });

    },

    async getXBAssets(type) {
      let key = `Investigation/${this.awbnumber}/`;
      let { data } = await fetchimageObject(key, this.myStr);
      if (data.statusCode == 100) {
        data.data.Contents.forEach(keys => {
          let type = (keys.Key.includes('Video')) ? 'video' : 'image'
          extractObjectFromKey(keys.Key, this.myStr).then(res => {
            const finalImage = res.data.ImageData.Body.data;
            let buff = new Buffer.from(finalImage);
            let base64data = buff.toString('base64');
            let assetData = `data:video/mp4;base64,${base64data}`;
            this.assetsByExecutive.push({ path: assetData, type });
          });
        });
      }
    },

    downloadImage(file) {
      this.Isvideo = ((file.attachment.type).toString().includes("video")) ? true : false;
      this.imgData = file.url;
      setTimeout(() => {
        const videoElement = this.$refs.videoPlayer;
        videoElement.src = file.url;
        videoElement.load();
      }, 2000);
      this.showModal = true;
    },

    closeImage() {
      this.showModal = false;
    },

    showImage(file) {
      this.Isvideo = (file.type == 'video') ? true : false;
      this.imgData = file.path;
      setTimeout(() => {
        const videoElement = this.$refs.videoPlayer;
        videoElement.src = file.path;
        videoElement.load();
      }, 2000);
      this.showModal = true;
    },
    isGoogleDriveLink(url) {
      return url && url.includes("drive.google.com");
    },
    convertToEmbedUrl(url) {
      const match = url.match(/(?:drive\.google\.com\/file\/d\/|id=)([^\/?]+)/);
      return match ? `https://drive.google.com/file/d/${match[1]}/preview` : url;
    },
    isImage(url) {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url);
    },
    isVideo(url) {
      return /\.(mp4|webm|ogg|mov)$/i.test(url);
    },
    downloadVideo(url) {
      if (this.isGoogleDriveLink(url)) {
        const fileId = this.extractGoogleDriveId(url);
        if (fileId) {
          window.open(`https://drive.google.com/uc?export=download&id=${fileId}`, '_blank');
        } else {
          alert('Invalid Google Drive link');
        }
      } else {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.extractFileName(url));
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    extractGoogleDriveId(url) {
      const match = url.match(/\/file\/d\/(.*?)\//);
      return match ? match[1] : null;
    },
    extractFileName(url) {
      return url.split('/').pop().split('?')[0] || 'video.avi';
    }
  },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/views/B2B components/editComponentOfRMApproval.vue?5e9c8f2d